<template>
  <div class="productcenterhtml">
    <div class="productcenterhead">
      <div class="productcenterheadtext">
        <p
          style="
            float: left;
            font-size: 18px;
            color: #275479;
            font-weight: bold;
            line-height: 30px;
            margin-left: 3px;
            letter-spacing: 2px;
          "
        >
          机构交易工具
        </p>
      </div>
    </div>
    <div class="productcenterbody">
      <div class="productcenterbodytag">
        <ul style="padding-top: 70px">
            <li class="pli" v-for="(item,index) in leftnav" :key="index">
                <div v-bind:class="[item.active ? class4 : class3]"></div>
                <div v-bind:class="[item.active ? class1 : class5]" @click="show(index)">
                    <div style="width: 45px; height: 40px; float: left"></div>
                    <div class="tagmid">{{item.text}}</div>
                    <div style="width: 30px; height: 40px; float: left"></div>
                </div>
                <div style="width: 9px; height: 7px; float: left;position:absolute;right:1px;bottom:-7px">
                    <img
                        src="../../assets/images/lan-jia.png"
                        style="display: block"
                        v-if="item.active"
                    />
                </div>
            </li>
        </ul>
      </div>
      <div style="height: 18px"></div>
      <div class="productcenterbodytext" ref="box">
        <div
          style="
            width: 780px;

            border-radius: 2%;
            position: relative;
          "
        >
          <div class="midtext">

            <div v-if="leftnav.filter((el)=>{return el.id=='dzh'})[0].active">
              <h4 class="head4" id="productcentertwo">一、多账号下单</h4>
              <p class="pproduct">
                多账号下单工具能够满足机构同时对多个交易账号进行下单的使用场景。支持不同期货公司、不同交易后台（CTP、金仕达、恒生多种后台）同时登陆，可配置20个交易账号同时交易。不仅支持画线下单、多账号条件单、多账号止损单，像使用单个账号交易一样简单，还支持多账号套利交易、移仓交易、下单任务管理器、算法分批下单等多种机构交易工具。
              </p>
              <p class="pproduct">
                根据不同交易机构的使用场景，提供了“一带多模式”和“投资经理/交易员模式”两种下单模式。
              </p>
              <h5 class="head5">一带多模式：</h5>
              <p class="pproduct">
                适用于交易员一个人管理多个交易账号的使用场景，可一键同时对多个账号进行下单。支持按倍率或份数自动计算交易手数，并提供了三键下单和传统下单两种交易界面可供选择。
              </p>
              <BaseBigimg :src="require('@/../public/proimg/1多账号.png')"></BaseBigimg>
              <h5 class="head5">投资经理/交易员模式：</h5>
              <p class="pproduct">
                适用于投资经理只负责主账号交易，交易员管理其他多个账号跟随主账号交易的使用场景。交易员账号支持按照倍率自动同步投资经理账号的委托下单，交易员监控交易过程，可手动撤单、追价、同步持仓。
              </p>
              <BaseBigimg :src="require('@/../public/proimg/2多账号.png')"></BaseBigimg>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='tljy'})[0].active">
              <h4 class="head4" id="productcenterthree">
                二、套利交易工具
              </h4>
              <p class="pproduct">
                自设套利交易不仅需要专业的套利交易工具，也需要更加专业的套利分析图表的支持。
              </p>
              <p class="pproduct">
                wh7不仅提供了超长的套利价差k线数据，且历史k线全部带上下影线，能展示更多的价差波动细节，还提供了套利统计工具，价差周期性、二腿价格走势图、二腿相关度、二腿价格走势百分比图、价差分布图等分析图表。系统还针对跨期套利合约到期换月的特点，对套利k线进行了数据清理，滤除了近月合约到期以后无法实际进行套利交易的数据。

              </p>
              <p class="pimg"><img src="@/../public/proimg/3套利.png" /></p>
              <p class="pproduct">
                wh7提供了专业的套利下单工具，不仅支持设置合约交易优先级、套利辅助算法交易，降低瘸腿概率；还支持套利挂单交易、套利风控单、套利分批交易，通过套利下单任务，实现每一批次自动监控价差，降低冲击成本；针对使用多账号交易的机构，还提供了多账号套利工具，支持合并委托、合并持仓，可一键多账号自动追价、一键平仓。
              </p>
              <BaseBigimg :src="require('@/../public/proimg/4套利.png')"></BaseBigimg>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='ycjy'})[0].active">
              <h4 class="head4" id="productcenterfour">三、移仓交易工具</h4>
              <p class="pproduct">
                传统软件将移仓和套利混为一谈，而实际移仓交易和套利交易是存在本质区别的。wh7基于移仓交易的特点，提供了专业的移仓分析、交易工具。
              </p>
              <p class="pproduct">
                wh7不仅提供了带上下影线的移仓价差k线，还提供了移仓成交量统计工具，移仓价差成交量统计、移仓量指标、价差周期性、二腿价格走势图、二腿价格走势百分比图、二腿相关度、价差分布图等分析图表。统计数据能展示不同价差区间的成交详情，可过滤掉无法成交的“虚假”价差，支持根据自身移仓手数制定移仓策略，判断出最适合的移仓价差点位。
              </p>
              <p class="pimg"><img src="@/../public/proimg/5移仓.png" /></p>
              <p class="pproduct">
                专用移仓交易工具，自动先平再开，支持移仓挂单交易，且支持分批移仓、移仓算法交易辅助，移仓任务自动监控每批移仓价差，价差符合条件再发送委托，降低移仓成本。还支持多账号移仓，移仓委托、移仓任务可合并显示，可一键对多个账号的移仓委托进行追价，像操作单个账号一样简单。
              </p>
              <BaseBigimg :src="require('@/../public/proimg/6移仓.png')"></BaseBigimg>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='qqjy'})[0].active">
              <h4 class="head4" id="productcenterfive">四、期权交易工具</h4>
              <p class="pproduct">
                软件提供了期权组合策略工具，支持商品期货期权及股指期货期权。提供了垂直套利、跨式套利、备兑套利、水平套利、合成标的以及自组策略等多种交易策略。不仅支持组合交易，还支持组合持仓风险分析、组合条件单、组合风控单、组合价格预警等交易工具。
              </p>
              <BaseBigimg :src="require('@/../public/proimg/qqzhcl-0.jpg')"></BaseBigimg>
              <p class="pproduct">
                软件还提供了趋势下单、成交统计等工具。
              </p>
              <p class="pimg"><img src="@/../public/proimg/8期权.png" /></p>
              <BaseBigimg :src="require('@/../public/proimg/9期权.png')"></BaseBigimg>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='rwglq'})[0].active">
              <h4 class="head4" id="productcenterthirteen">
                五、下单任务管理器
              </h4>
              <p class="pproduct">
                添加多个下单任务，让软件自动监控价格，符合价格条件时自动执行下单任务，交易员只需关注交易日志和任务执行进度。
              </p>
              <!-- <h5 class="head5">智能分批降低冲击成本</h5> -->
              <p class="pproduct">
                下单任务管理器可智能分批降低冲击成本，根据不同合约的活跃程度，设定每批下单手数，在确保不破坏趋势的前提下，提高成交效率。同时还可添加偏离条件，当价格偏移过大时暂停交易，价格回归以后自动继续下单，以确保所有订单成交在相同的价格附近。
              <p class="pimg" style="padding-bottom: 0">
                <img src="@/../public/proimg/jyrw2.jpg" width="530" />
              </p>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='wgjy'})[0].active">
              <h4 class="head4" id="productcentertwlf">六、网格交易运行池</h4>
              <p class="pproduct">
                网格策略适用于震荡行情，启动后可自动循环执行高抛低吸买卖操作。
              </p>
              <p class="pproduct">网格交易运行池提供以下两种网格策略：</p>
              <h5 class="head5">1、单向网格策略</h5>
              <p class="pproduct">
                策略算法：
              </p>
              <p class="pproduct">以震荡向上行情做多为例：首次开仓需手动委托（启动网格策略），开多成交后自动以成交价/委托价+M点挂出平多委托，等待高抛；高抛成交后，自动以平仓成交价/委托价-N点挂出开多委托，等待低吸；如此循环。M、N、循环次数均可设置。</p>
              <p class="pimg" style="padding-bottom: 0">
                <img src="@/../public/proimg/wgcl1.png" />
              </p>
              <!-- <p class="pproduct" style="text-align: center; font-size: 13px">
                震荡向上行情网格策略执行效果示意图
              </p> -->
              <h5 class="head5">2、固定网格策略</h5>
              <p class="pproduct">
                策略算法（双向下单、以最新价为基准价为例）：
              </p>
              <p class="pproduct">
                点击“启动”按钮，软件以最新价为基准，在最新价上下发出渔网式委托，即在最新价之上和之下同时发出M笔卖开和M笔买开委托，每笔委托价差间隔(Q)相同、委托手数相同；
              </p>
              <p class="pproduct">
                等待行情变动，当挂出去的任意一笔开仓委托成交后，软件会自动挂出Q点盈利的止盈委托单，等待盈利收网；止盈成交后，自动在原开仓价位重新挂出开仓委托，重新补网。
              </p>
              <p class="pimg" style="padding-bottom: 0">
                <img src="@/../public/proimg/wg-2.jpg" width="530px"/>
              </p>
              <p class="pproduct" style="padding-top:25px">
                网格交易运行池支持多个期货合约或套利合约同时进行网格策略交易，支持批量监控、批量删除。
              </p>
              <p class="pimg" style="padding-bottom: 0">
                <img src="@/../public/proimg/wg-3.jpg"  width="530px"/>
              </p>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='wjxd'})[0].active">
              <h4 class="head4" id="productcenterfifteen">七、文件下单</h4>
              <p class="pproduct">
                使用文件下单功能可以快速将Excel 或 Python 等文件生成 csv 格式交易指令转变为账户持仓。系统自动扫描文件发送委托、控制下单间隔，方便、快速、准确。
              </p>
              <p class="pproduct">
                使用步骤如下图所示：
              </p>
              <p class="pimg"><img src="@/../public/proimg/wjxd2.jpg" /></p>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='fpxd'})[0].active">
              <h4 class="head4" id="productcenterfourteen">八、算法分批下单</h4>
              <p class="pproduct">
                算法分批下单内置多种经典算法交易策略，只需填写参数即可使用策略，可自动监控行情变化、委托回报等交易信息，加强对交易过程的精细化控制，实现智能分批，达到减少成交滑点，提高交易效率的目的。
              </p>
              <p class="pproduct">
                文华原创期货算法策略“<strong>小鬼搬砖</strong>”，针对期货、期权合约的盘口流动性特点，根据盘口当时的实时情况，综合使用排队价、对手价、插队价方式智能分批下单（<a
                  href="https://www.wenhua.com.cn/popwin/7sfjy.htm"
                  class="eeee"
                  target="_blank"
                  >点击查看算法策略说明</a
                >）。
              </p>
              <p class="pimg" style="padding-bottom: 0">
                <BaseBigimg :src="require('@/../public/proimg/算法分批.jpg')"></BaseBigimg>
              </p>
              <p class="pproduct">
                软件还支持多账号算法拆单，且提供了多账号手数分配算法。交易员可根据合约盘口成交状态，确定并输入单批次委托手数，系统自动按照账号权重分配手数。
              </p>
              <p class="pimg" style="padding-bottom: 0">
                <BaseBigimg :src="require('@/../public/proimg/算法分批2.jpg')"></BaseBigimg>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      leftnav:[{active:true,text:'多账号下单',id:'dzh'},
      {active:false,text:'套利交易工具',id:'tljy'},
      {active:false,text:'移仓交易工具',id:'ycjy'},
      {active:false,text:'期权交易工具',id:'qqjy'},
      {active:false,text:'下单任务管理器',id:'rwglq'},
      {active:false,text:'网格交易运行池',id:'wgjy'},
      {active:false,text:'文件下单',id:'wjxd'},
      {active:false,text:'算法分批下单',id:'fpxd'}],
      class1: "onclick",
      class2: "noclick",
      class3: "touming",
      class4: "yellow",
      class5: "noclickone",
      class6: "noclickele",
    };
  },
  methods: {
    show(index){
        console.log()
        this.leftnav.forEach((el,idx)=>{
            el.active=false
        })
        this.leftnav[index].active=true
    },
   
  },
  created(){
    this.leftnav.forEach((el,idx)=>{
            el.active=false
    })
    this.leftnav.filter((el)=>{
      return el.id==this.$route.params.id
    })[0].active=true
  }

};
</script>

<style scoped>
.eeee {
  color: blue;
}
.eeee :visited {
  color: blue;
}
.productcenterhtml {
  background: url("../../assets/images/ts-bg_02.jpg") no-repeat top, #eef0ff;
  /* background-size: 100% 100%; */
  min-width: 1400px;
  width: 100%;
}
.productcenterhead {
  position: relative;
  height: 140px;
  width: 1000px;
  margin: 0 auto;
}
.productcenterheadtext {
  position: absolute;
  top: 105px;
  left: 3px;
}
.productcenterbody {
  width: 1000px;
  margin: 0 auto;
  position: relative;
}
.productcenterbodytag {
  width: 570px;
  height: 476px;
  border-radius: 2%;
  background: url("../../assets/images/ts-1_01.png") no-repeat center;
  /* background-size: 100% 100%; */
  position: absolute;
}
.productcenterbodytext {
  margin-left: 220px;
  width: 780px;
  border-top-left-radius: 1em;
  background: url("../../assets/images/ts-1_02.jpg") no-repeat top, #f7f7f7;
  background-size: 100%;
  overflow-x: hidden;
  filter: drop-shadow(1px 1px 2px #c2c5d4);
  min-height: 680px;
  z-index: 999;
}
.noclick {
  height: 41px;
  line-height: 41px;

  width: 220px;
  border-top: 1px solid #2f5476;
  letter-spacing: 1px;
  color: #85c0ea;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.onclick {
  height: 42px;
  line-height: 42px;
  background: #fdfdfd;

  width: 220px;

  color: #395774;
  text-align: left;
  letter-spacing: 1px;

  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.touming {
  width: 5px;
  height: 42px;
  float: left;
}
.yellow {
  width: 5px;
  height: 42px;
  background: #e3a200;
  float: left;
  border-top-left-radius: 0.1em;
  border-bottom-left-radius: 0.1em;
}
.head4 {
  color: #245376;
  font-size: 16px;
  padding-top: 20px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
.midtext {
  width: 680px;
  margin: 0 auto;
  padding-bottom: 30px;
}
.pproduct {
  font-size: 15px;
  padding-top: 3px;
  padding-bottom: 3px;
  text-indent: 2em;
  color: #727983;
  line-height: 25px;
  /* width: 640px; */
  text-align: justify;
  letter-spacing: 1px;
}
.pimg {
  padding-top: 10px;
  padding-bottom: 10px;
  min-height: 50px;
  width: 100%;
  text-align: center;
}
.noclick:hover {
  color: #e3a200;
}
.pli {
  width: 235px;
  height: 42px;
  margin-left: -5px;
  position: relative;
  z-index: 88;
}
.noclickone {
  height: 41px;
  line-height: 41px;

  letter-spacing: 1px;
  width: 220px;

  border-top: 1px solid #2f5476;
  color: #85c0ea;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.pli:last-child .noclickone{
  border-bottom: 1px solid #2f5476;
}
.noclickele {
  height: 40px;
  line-height: 40px;

  letter-spacing: 1px;
  width: 220px;
  border-top: 1px solid #2f5476;
  border-bottom: 1px solid #2f5476;
  color: #85c0ea;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.noclickone:hover {
  color: #f59726;
}
.noclickele:hover {
  color: #f59726;
}
.tagmid {
  width: 130px;
  height: 42px;
  float: left;
  font-weight: bold;
}
.head5 {
  color: #245376;
  font-size: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
</style>